var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignOutIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.91917 13.5698C10.5649 13.5698 11.0884 14.0933 11.0884 14.7391C11.0884 15.3847 10.5649 15.9082 9.91917 15.9082C9.27346 15.9082 8.75 15.3847 8.75 14.7391C8.75 14.0933 9.27346 13.5698 9.91917 13.5698Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 5.23311V12.4032L14.0005 12.9924L22.6823 12.9912L20.6728 10.9802C20.3622 10.6695 20.334 10.1834 20.5882 9.84089L20.673 9.74277C20.9837 9.43218 21.4697 9.40402 21.8123 9.65825L21.9104 9.74298L25.4064 13.2402C25.7168 13.5507 25.7452 14.0362 25.4916 14.3788L25.407 14.4769L21.911 17.9808C21.5697 18.323 21.0157 18.3236 20.6736 17.9822C20.3626 17.672 20.3338 17.1859 20.5875 16.8431L20.6722 16.7449L22.6706 14.7412L14.0005 14.7424L13.9999 22.6116C13.9999 23.1557 13.5085 23.5679 12.9728 23.4733L3.05606 21.7218C2.638 21.6479 2.33325 21.2846 2.33325 20.8601V6.86159C2.33325 6.43307 2.6436 6.0676 3.06647 5.99816L12.9832 4.36969C13.5159 4.2822 13.9999 4.69326 13.9999 5.23311ZM12.2499 6.26353L4.08325 7.60462V20.1261L12.2499 21.5685V6.26353Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1667 21.738L16.0595 21.7383L16.1782 21.7302C16.6058 21.6721 16.9352 21.3053 16.9345 20.8618L16.9261 15.9032H15.1667V21.738Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1691 11.8199L15.1667 10.3328V5.98657L16.0363 5.98658C16.4787 5.98658 16.8445 6.31502 16.9031 6.74155L16.9113 6.86014L16.9191 11.8199H15.1691Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignOutIcon);
export default __webpack_public_path__ + "static/media/SignOutIcon.1499853a5dbe362252a7cd045eaff251.svg";
export { ForwardRef as ReactComponent };